/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".pill-container[_ngcontent-%COMP%]{border:1px solid #d9d9d9;border-radius:40px;padding:6px 10px;margin:5px;background-color:#fff;box-shadow:0 2px 4px rgba(0,0,0,.1);font-size:14px}.pill-container[_ngcontent-%COMP%]   i[type=close][_ngcontent-%COMP%]{line-height:1em;vertical-align:middle;cursor:pointer;margin-left:5px;transition:color .3s ease}.pill-container[_ngcontent-%COMP%]   i[type=close][_ngcontent-%COMP%]:hover{color:#de393d}"];
export { styles as styles };
